<template>
    <ListenerArtistLibrary v-if="isListenerMobile" />
    <ArtistLibrary v-else />
</template>

<script>
import ArtistLibrary from './ArtistLibrary.vue'
import ListenerArtistLibrary from './ListenerArtistLibrary.vue'

export default {
    name: 'artists',
    components: {
        ArtistLibrary,
        ListenerArtistLibrary
    },
    computed: {
        isListenerMobile() {
            return !this.$store.state.common.isSuperuser
                && typeof window !== 'undefined'
                && window.innerWidth <= 768
        }
    }
}
</script>
